import { useTheme } from "@stores/ThemeContext";
import shield_team_a from '@assets/svg/statsTab/shield_team_a.svg';
import shield_team_b from '@assets/svg/statsTab/shield_team_b.svg';
import shield_team_a_dark from '@assets/svg/statsTab/shield_team_a_dark.svg';
import shield_team_b_dark from '@assets/svg/statsTab/shield_team_b_dark.svg';
import { T } from "@utils/enums";
import DynamicShield from "@components/StatsConsole/Widgets/common/StatsScoreboardTeam/DynamicShield/DynamicShield";
import { useColorContext } from "@stores/ColorContext";

type Iteam = 'team_a' | 'team_b' | 'team_a_dark' | 'team_b_dark';

interface ILatestMatchesTeamProps {
    team: Iteam;
    homeTeam: string | null;
    awayTeam: string | null;
}

const imageMapLight = {
    team_a: shield_team_a,
    team_b: shield_team_b,
    team_a_dark: shield_team_a_dark,
    team_b_dark: shield_team_b_dark
};

const imageMapDark = {
    team_a: shield_team_a_dark,
    team_b: shield_team_b_dark,
    team_a_dark: shield_team_a_dark,
    team_b_dark: shield_team_b_dark
};

export const LatestMatchesTeam = ({ team, homeTeam, awayTeam }: ILatestMatchesTeamProps) => {
    const { theme } = useTheme();
    const shieldTeam = theme === T.DARK ? imageMapDark[team] : imageMapLight[team];
    const teamName = team.includes('team_a') ? homeTeam : awayTeam;
    const {colors} = useColorContext();

    return (
        <div className='h-[24px] gap-[8px] flex flex-row justify-center items-center max-w-[319px]'>
            <DynamicShield color={teamName === homeTeam ? colors?.homeColor : colors?.awayColor} />
            <div className='font-normal font-robotoRegular text-[12px] leading-[16px] text-base120 dark:text-monoY truncate'>
                {teamName}
            </div>
        </div>
    );
}


